(function () {
    'use strict';
    var m = angular.module('profiles');
    m.controller('OrganizationProfileController', ["$scope", "$routeParams", "widgetPolling", "sizeClasses", function ($scope, $routeParams, widgetPolling, sizeClasses) {
        //widgetPolling.updateWidgets('organization', {
        //    id: $routeParams.id
        //});
        $scope.widgetPolling = widgetPolling;
        $scope.getSizeClasses = sizeClasses;
    }]);
}());